/**
 * Central brand config — the single code seam for all user-facing product
 * naming. Values come from `BUN_PUBLIC_*` env (Bun only exposes that prefix to
 * the client bundle) with NSI Capitals defaults, so this file stays byte-identical
 * across white-label repos and only each repo's `.env` differs. To reskin, set
 * the env vars; to restyle colors, edit `src/styles/brand-theme.css`.
 */
export const brand = {
  name: process.env.BUN_PUBLIC_APP_NAME ?? "NSI Capitals",
  tagline: process.env.BUN_PUBLIC_APP_TAGLINE ?? "tax filing made simple",
  description:
    process.env.BUN_PUBLIC_APP_DESCRIPTION ?? "NSI Capitals — tax filing made simple.",
  portalDomain: process.env.BUN_PUBLIC_PORTAL_DOMAIN ?? "portal.nsicapitals.com",
} as const;
